import { swSettings } from "app/common/services/swSettings";
import type { Banner } from "app/components/React/TrialBanner/utils/trialBannerConfig";
import { getBannerText } from "app/components/React/TrialBanner/utils/trialBannerHelpers";
import { i18nFilter } from "app/filters/i18nFilter";
import { isTraditionalTrialUser } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { TrialTextStyled } from "./StyledTrialText";

const i18n = i18nFilter();

interface ITrialTextProps {
    bannerType: Banner;
    shouldGoToAfterTrial?: boolean;
}

const TrialText = ({ bannerType, shouldGoToAfterTrial }: ITrialTextProps) => {
    const text = getBannerText(bannerType, i18n, swSettings);
    if (!text) {
        return null;
    }
    const isTrialUser = isTraditionalTrialUser(swSettings);

    return (
        <TrialTextStyled
            isUserWithoutTrial={shouldGoToAfterTrial}
            isBoldText={isTrialUser}
        >
            <span dangerouslySetInnerHTML={{ __html: text }} />
        </TrialTextStyled>
    );
};

export default TrialText;
